import ApiClient from 'remote/api-client';

const create = (): Promise<void> => ApiClient.post('/verification-email-request').promise();

export default { create };
